import { IOfferCard } from '../../../types';

export const isNewbuilding = ({ dealType, offerType, newbuilding }: IOfferCard) =>
  dealType === 'sale' && offerType === 'flat' && Boolean(newbuilding && newbuilding.isFromDeveloper);
